import "@mdi/font/css/materialdesignicons.css";

import "vuetify/styles";



import { createVuetify } from "vuetify";

import { getStoredPreferences } from "@/utils/themePreferences.js";



const appFontFamily =

  '"DM Sans", system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';



const storedPrefs = getStoredPreferences();



export default createVuetify({

  defaults: {

    VDialog: {
      scrim: true,
    },

    VCard: {
      rounded: "xl",
    },

    VTooltip: {
      location: "top",
      openDelay: 200,
    },

    VMenu: {
      offset: 6,
    },

    VTextField: {
      rounded: "xl",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },

    VSelect: {
      rounded: "xl",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },

    VAutocomplete: {
      rounded: "xl",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
      inputProps: {
        autocomplete: "new-password",
      },
    },

    VCombobox: {
      rounded: "xl",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },

    VFileInput: {
      rounded: "xl",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },

    VTextarea: {
      rounded: "lg",
      variant: "outlined",
      density: "comfortable",
      color: "primary",
    },

    VBtn: { ripple: false },

    VListItem: { ripple: false },

  },

  theme: {

    defaultTheme: storedPrefs.mode,

    themes: {

      light: {

        dark: false,

        colors: {

          primary: storedPrefs.primaryColor,

          secondary: "#bd58b0",

          theme: "#09719e",

          background: "#faf7fd",

          surface: "#ffffff",

        },

        variables: {

          "font-family": appFontFamily,

        },

      },

      dark: {

        dark: true,

        colors: {

          primary: storedPrefs.primaryColor,

          secondary: "#bd58b0",

          theme: "#09719e",

          background: "#0c0e14",

          surface: "#1a1d27",

        },

        variables: {

          "font-family": appFontFamily,

        },

      },

    },

  },

  display: {

    mobileBreakpoint: "sm",

    thresholds: {

      xs: 0,

      sm: 600,

      md: 960,

      lg: 1280,

      xl: 1920,

    },

  },

});


